<template>

    <div class="fetch">

        <div class="fetch__container">

            <div class="fetch__top">

                <img src="/img/fetch/logo-large-white.svg" class="fetch__top__logo">

            </div>

            <div class="fetch__body">

                <div class="circle-empty">
                    <img src="/img/fetch/exclamation-circle.svg" class="img__20">
                </div>

                <p class="text-xlSemibold-2 mt__16">{{ $t('fetch_done_empty_title') }}</p>

                <p class="text-baseMedium mt__4">{{ $t('fetch_done_empty_desc') }}</p>

            </div>

            <div class="fetch__bottom">

                <button class="cta-empty-add text-lSemibold color__white"
                        @click="goAddIndox">{{ $t('fetch_done_add_inbox_cta') }}
                </button>

                <button class="cta-empty-stats text-lSemibold"
                        @click="goStats">{{ $t('cleaning_list_cta_stat') }}
                </button>

            </div>

        </div>

    </div>

</template>

<script>
import Tag from '@/modules/tag'

export default {

    name: 'fetch-end-empty',

    mounted() {
        Tag.pageViewGA(this, 'fetch_done_empty')
    },

    methods: {

        goAddIndox() {
            Tag.clickGA(this, 'add_inbox')
            this.$router.push({path: '/add-inbox'})
        },

        goStats() {
            Tag.clickGA(this, 'stats')
            this.$router.push({path: '/stats'})
        }

    }
}
</script>

<style lang="scss" scoped>

.fetch {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    background-color: $aquamarine;
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    background-image: url("/img/fetch/illustration-fetch-empty-desktop.svg");

    &__container {
        display: flex;
        flex-direction: column;
        flex: 1;
        max-width: 480px;
        @media screen and (min-width: $above-tablet-length) {
            padding: 16px 0 24px;
        }
    }

    &__top {
        display: flex;
        flex-direction: column;
        padding: 16px;
        min-height: 134px;
        justify-content: center;

        &__logo {
            height: 40px;

            @media screen and (min-width: $above-tablet-length) {
                margin-bottom: 30px;
            }
        }
    }

    &__body {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-grow: 1;
        padding: 0 16px;
        @media screen and (min-width: $above-tablet-length) {
            padding-top: 26px;
        }
    }

    &__bottom {
        padding: 0 16px 24px;
    }

    .circle-empty {
        width: 40px;
        height: 40px;
        background-color: $white;
        border-radius: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .cta-empty-add {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 16px 40px;
        border-radius: 32px;
        background-color: $midnight;
    }

    .cta-empty-stats {
        margin-top: 8px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 16px 40px;
        border-radius: 32px;
        background-color: $white;
    }

}

</style>
